import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Redo.svg",
  "use": "Redo.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Redo.svg\"><path d=\"M30.0348,48.0208H46.0474a2,2,0,1,1,0,4H30.0348a18,18,0,1,1,0-36h9.997V11.0384a1.0255,1.0255,0,0,1,1.62-.8191l9.956,6.9889a.9964.9964,0,0,1,0,1.638l-9.956,6.9889a1.0255,1.0255,0,0,1-1.62-.8191V20.0209h-9.997a14,14,0,1,0,0,28Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol